export default __webpack_public_path__ + "03242a3fccd185e23a475e3980412a6c.svg";